<script setup lang="ts">
import { ref, watch } from 'vue';
import { UiDialog, UiText, UiTextarea } from '@shopexperts/shared';

defineProps<{
  isLoading?: boolean;
}>();

const model = defineModel<boolean>({ default: false });

const emit = defineEmits<{
  confirm: [notes: string];
  cancel: [];
}>();

const moderationNotes = ref('');

watch(model, (isOpen) => {
  if (!isOpen) {
    moderationNotes.value = '';
    emit('cancel');
  }
});

const handleConfirm = () => {
  emit('confirm', moderationNotes.value);
};

const handleCancel = () => {
  model.value = false;
};
</script>

<template>
  <UiDialog
    v-model="model"
    title="Delete Review"
    text="Are you sure you want to permanently delete this review? This action cannot be undone."
    primary-action-label="Delete Permanently"
    secondary-action-label="Cancel"
    @primary-action="handleConfirm"
    @secondary-action="handleCancel"
  >
    <UiText 
      as="p" 
      variant="p-small"
      text="⚠️ Warning: This will permanently remove the review from the system."
      class="text-red-600 font-medium mb-4"
    />
    <UiTextarea
      v-model="moderationNotes"
      label="Reason for Deletion"
      placeholder="Enter reason for deleting this review..."
      :rows="4"
      :disabled="isLoading"
      required
    />
  </UiDialog>
</template>
